const PaymentStatusOptions = [
  {
    label: 'Paid',
    value: 'PAID',
    classes: 'bg-emerald-100 text-emerald-800'
  },
  {
    label: 'Unpaid',
    value: 'UNPAID',
    classes: 'bg-red-100 text-red-800'
  },
  {
    label: 'Partially Paid',
    value: 'PARTIALLY_PAID',
    classes: 'bg-amber-100 text-amber-800'
  }
]

export default PaymentStatusOptions
